export const DataObstetrics = [
    {
        id:1,
        image:"/Images/Maternity/Obstetrics/Normal-Delivery.webp",
        title:"Normal Vaginal Delivery",
    },
    {
        id:2,
        image:"/Images/Maternity/Obstetrics/Painless-Delivery.webp",
        title:"Painless Delivery",
    },
    {
        id:3,
        image:"/Images/Maternity/Obstetrics/High-Risk.webp",
        title:"High Risk Pregnancy Care",
    },
    {
        id:4,
        image:"/Images/Maternity/Obstetrics/Preterm-Delivery.webp",
        title:"Preterm Delivery Care",
    },
    {
        id: 5,
        image: "/Images/Maternity/Obstetrics/Postnatal-Care.webp",
        title: "Postnatal Care",
    },
    {
        id: 6,
        image: "/Images/Maternity/Obstetrics/Antenatal-Care.webp",
        title: "Prenatal / Antenatal Care",
    },
    {
        id: 9,
        image: "/Images/Maternity/Obstetrics/LDRP.webp",
        title: "LDRP (Labour, Delivery, Recovery, and Postpartum care)",
    },
    {
        id: 10,
        image: "/Images/Maternity/Obstetrics/Postpartum Care.webp",
        title: "Postpartum Care",
    },
    {
        id: 11,
        image: "/Images/Maternity/Obstetrics/Caesarean.webp",
        title: "Caesarean Section",
    },
    {
        id: 12,
        image: "/Images/Maternity/Obstetrics/Cervical Cerclage.webp",
        title: "Cervical Cerclage",
    },
];

